// AppAuthWithIdToken.js
import React from "react";
import { withAuth0 } from "@auth0/auth0-react";
import IdTokenContext from "./IdTokenContext";
import AppAuth from "../AppAuth";

function AppAuthWithIdToken(props) {
  return (
    <IdTokenContext.Consumer>
      {(idCtx) => <AppAuth {...props} idTokenCtx={idCtx} />}
    </IdTokenContext.Consumer>
  );
}

export default withAuth0(AppAuthWithIdToken);